"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.amplifyUuid = void 0;
const uuid_1 = require("uuid");
const amplifyUuid = uuid_1.v4;
exports.amplifyUuid = amplifyUuid;
